import { findSelector, resource } from "data/helpers/apiv3";
import { Postcard } from "data/records";

const [api, actions] = resource(Postcard, []);

const selectors = {
  ...findSelector(Postcard),
  byParent: (state, parentType, parentId) =>
    state.apiv3.postcard.id.find((p) => p.associatedObjectId === parentId && p.associatedObjectType === parentType),
};

const reducers = {};

const initialState = {};

export {
  api as postcardApi,
  actions as postcardActions,
  selectors as postcardSelectors,
  reducers as postcardReducers,
  initialState as postcardInitialState,
};
